import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type freeToStandardRefreshModalQuery,
	type JiraProjectType,
} from './__generated__/freeToStandardRefreshModalQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	projectType: JiraProjectType;
};

export const entryPoint: EntryPoint<
	EntryPointComponent<
		{
			freeToStandardRefreshModalQuery: freeToStandardRefreshModalQuery;
		},
		Record<string, never>,
		{
			onClose: () => void;
		},
		Record<string, never>
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-free-to-standard-refresh-modal" */ './free-to-standard-refresh-modal'
			),
		{
			moduleId: 'edition-awareness-free-to-standard-refresh-modal',
		},
	),
	getPreloadProps: ({ cloudId, projectType }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			freeToStandardRefreshModalQuery: {
				parameters,
				variables: {
					cloudId,
					projectType,
				},
			},
		},
	}),
});
